<div class="workflow-finxone-table">
  <p-table
    #workflowFinxTable
    class="d-block overflow-x-auto p-datatable-gridlines"
    [columns]="columns"
    [value]="entityData"
    [paginator]="pagingEnabled && !!entityData?.length"
    [showCurrentPageReport]="true"
    [currentPageReportTemplate]="currentPageReport"
    [rows]="pageSize"
    [lazy]="lazyLoad"
    [scrollable]="true"
    scrollHeight="350px"
    [totalRecords]="totalListCount"
    [rowsPerPageOptions]="viewPaginationOptionValue"
    (onPage)="onPageChange($event)"
    (onLazyLoad)="loadCustomers($event)"
    [paginatorDropdownAppendTo]="'body'"
    [globalFilterFields]="globalFilterFields"
  >
    <!--  Search template -->
    <ng-template *ngIf="enableSearch" pTemplate="caption">
      <div class="p-datatable-header">
        @if (showHeadingWithSearch) {
        <ng-container *ngTemplateOutlet="searchWithHeader"></ng-container>
        } @else {
        <ng-container *ngTemplateOutlet="searchInput"></ng-container>
        }
      </div>
    </ng-template>

    <!-- Header template -->
    <ng-template pTemplate="header" let-columns>
      <th styleClass="p-datatable-gridlines" *ngFor="let col of columns">
        {{ col.label }}
      </th>
      <th *ngIf="isShowMoreOption">&nbsp;</th>
      <th *ngIf="showTableActions" class="text-right pr-6">Actions</th>
    </ng-template>

    <!-- Body template -->

    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns">
      <tr
        (click)="onClick(rowData)"
        (contextmenu)="openContextMenu($event, rowData, rowIndex)"
        [class.tr-hover-effects]="enableHoverEvent"
      >
        @for (col of columns; track col.value) {

        <!-- Column type checkbox -->
        @if (col?.columnSettings?.columnType === ColumnType.CHECKBOX) {

        <ng-container
          *ngTemplateOutlet="
            checkboxContent;
            context: {
              rowData,
              col
            }
          "
        ></ng-container>

        }
        <!-- Column type text input -->
        @else if(col?.columnSettings?.columnType === ColumnType.INPUT) {

        <ng-container
          *ngTemplateOutlet="
            textInputContent;
            context: {
              rowData,
              col
            }
          "
        ></ng-container>

        }

        <!-- Column type dropdown -->
        @else if(col?.columnSettings?.columnType === ColumnType.DROPDOWN) {

        <ng-container
          *ngTemplateOutlet="
            dropdownContent;
            context: {
              rowData,
              col
            }
          "
        ></ng-container>

        }
        <!-- existing flow type renderContentAsHtml -->
        @else { @if (renderContentAsHtml) {
        <td
          [innerHTML]="rowData[col.value] | safeHtml"
          [class.disabled-content]="rowData?.isContentDisabled"
        ></td>
        } @else {
        <td>{{ rowData[col.value] }}</td>
        } }} @if(isShowMoreOption){
        <td class="width-action-row">
          @if(rowData?.actionEnabled === false){
          <div></div>
          } @else{
          <div class="more-icon">
            <mat-icon
              class="is-pointer"
              (click)="moreOption(rowData.id, $event)"
              svgIcon="more-img-option"
            ></mat-icon>
          </div>
          }
        </td>
        } @if(showTableActions){ @if(!tableActionsConfigurations || tableActionsConfigurations.length === 0){
        <td>
          <div></div>
        </td>
        } @else{
        <td>
          <div class="width-action-row text-right-important">
            @for (action of tableActionsConfigurations; track action.actionType) { @if (action.type ===
            'button') {
            <button
              [class]="action.buttonStyleClass"
              (click)="handleActionClick({ actionType: action.actionType, rowData })"
            >
              {{ action.buttonLabel }}
            </button>
            } @if (action.type === 'icon') {
            <mat-icon
              class="cursor-pointer"
              (click)="handleActionClick({ actionType: action.actionType, rowData })"
              [svgIcon]="action.icon ?? ''"
            ></mat-icon>
            } }
          </div>
        </td>
        }
        <div *ngIf="isShowOption" class="show-more-options pb-1" (clickOutside)="closeMenu()">
          @for(link of actionOptions; track link.value){ @if( !link?.isIdNotExist || (link?.isIdNotExist &&
          !rowData?.[link.isIdNotExist]) ){
          <span
            class="is-pointer"
            (click)="navigateTo(link.value, rowData.id)"
            [ngClass]="{
              disabled: rowData?.showMenuPopup ?? false,
              'highlighted-option': link.value?.includes('remove') || link.value?.includes('retry')
            }"
          >
            {{ link.label }}
          </span>
          } }
        </div>
        } @if (isContextMenuOpen && selectedIndex === rowIndex) {
        <ng-container *ngTemplateOutlet="contextMenuTemplate"></ng-container>
        }
      </tr>
    </ng-template>

    <!-- No data template -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="columns.length + 1">
          <div style="text-align: center">{{ emptyTableMsg }}</div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<ng-template #searchWithHeader>
  <div class="row mx-0 align-items-center">
    <div class="col-10 heading-wrapper">
      <h3 class="mb-1">{{ heading.title }}</h3>
      <p class="m-0">{{ heading.subTitle }}</p>
    </div>
    <div class="col-2">
      <ng-container *ngTemplateOutlet="searchInput"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #searchInput>
  <div [class]="searchBoxClass" class="search-input">
    <span class="search-box w-100">
      @if(lazyLoad){
      <workflow-finx-input
        type="text"
        class="w-100"
        [prefixIcon]="true"
        [placeholder]="searchPlaceHolder"
        (input)="searchValue($event)"
      >
        <img prefixIcon class="prefix-icon" alt="search-icon" src="assets/images/search.svg"
      /></workflow-finx-input>
      } @else {
      <workflow-finx-input
        type="text"
        class="w-100"
        [placeholder]="searchPlaceHolder"
        [prefixIcon]="true"
        (input)="workflowFinxTable.filterGlobal($any($event.target).value, 'contains')"
        ><img prefixIcon class="prefix-icon" alt="search-icon" src="assets/images/search.svg"
      /></workflow-finx-input>
      }
    </span>
  </div>
</ng-template>

<ng-template #contextMenuTemplate>
  <finxone-menu
    [menuVariant]="'workflowMenu'"
    [contextMenuEvent]="contextMenuEvent"
    [menuItemList]="menuItemList"
    (menuItemClickEvent)="contextMenuClick($event)"
    (clickOutside)="resetContextMenuState()"
  ></finxone-menu>
</ng-template>

<!-- Column type checkbox -->
<ng-template #checkboxContent let-rowData="rowData" let-col="col">
  <td>
    <div class="is-center">
      <workflow-finx-input
        type="checkbox"
        [checked]="rowData[col.value] ?? false"
        (checkboxValueChanges)="toggleColumnCheckbox($event, rowData, col.value)"
      ></workflow-finx-input>
    </div>
  </td>
</ng-template>

<!-- Column type text input -->
<ng-template #textInputContent let-rowData="rowData" let-col="col">
  <td>
    <div class="d-flex">
      <workflow-finx-input
        [type]="col?.columnSettings?.inputType || 'text'"
        [value]="rowData[col.value]"
        (change)="onChangeColumnText($event, rowData, col.value)"
      ></workflow-finx-input>
    </div>
  </td>
</ng-template>

<!-- Column type dropdown -->
<ng-template #dropdownContent let-rowData="rowData" let-col="col">
  <td>
    <div class="d-flex">
      <workflow-finx-dropdown
        [options]="col?.columnSettings?.dropdownOptions"
        [optionLabel]="col?.columnSettings?.dropdownOptionLabel"
        [optionValue]="col?.columnSettings?.dropdownOptionValue"
        [value]="rowData[col.value]"
        id="column-dropdown"
        appendto="body"
        class="w-100"
        (valueChange)="onChangeDropdownValue($event, rowData, col.value)"
      >
      </workflow-finx-dropdown>
    </div>
  </td>
</ng-template>
